import { DataGridPremium, useGridApiRef } from '@mui/x-data-grid-premium';
import { useCopyToClipboard } from 'ui/molecules/TableGrids';
import useChildTransactions from './useChildTransactions';
import ChildTransactionsToolbar from './ChildTransactionsToolbar';

const ChildTransactions = () => {
    const apiRef = useGridApiRef();

    useCopyToClipboard(apiRef, {
        isEnabled: true,
        ignoreFields: []
    });

    return (
        <DataGridPremium
            {...useChildTransactions()}
            disableSelectionOnClick
            apiRef={apiRef}
            sx={{
                minHeight: 250
            }}
            components={{
                Toolbar: ChildTransactionsToolbar
            }}
        />
    );
};

export default ChildTransactions;
